import { eachMonthOfInterval, getTime, toDate, Interval } from 'date-fns';
import { getMonthName, isValidInterval } from '@e2m-customer-portal/shared';
import { Month } from '../generated/graphql';

export function getMonths(data: Month | Month[] | Date | number | Interval): Month[] {
  const months: Month[] = [];
  if (Array.isArray(data)) {
    months.push(...data);
  } else if (typeof data === 'string') {
    months.push(data);
  } else if (data instanceof Date) {
    months.push(getMonthName(data) as Month);
  } else if (typeof data === 'number') {
    months.push(getMonthName(toDate(data)) as Month);
  } else if (isValidInterval(data)) {
    months.push(
      ...eachMonthOfInterval(data)
        .filter((date) => getTime(date) !== getTime(data.end))
        .map((date) => getMonthName(date) as Month),
    );
  }
  return months;
}
